import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import pic from '../pic.png';
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";


function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [toolsOpen, setToolsOpen] = useState(false);
  const navigate = useNavigate();

  // Déconnexion
  const handleLogout = () => {
    localStorage.removeItem("token");
    // Ajoute ici tout cleanup éventuel (user, etc)
    navigate("/"); // adapte la route si nécessaire
  };

  return (
    <header className="navbar">
      <Link to="/admin/home" className="logo">
        <img className="h-10 w-auto object-contain" src={pic} width="120px" alt="Logo" />
      </Link>

      {/* Desktop nav */}
      <nav className="nav-links">
        <Link to="/admin/home">Accueil</Link>
        <Link to="/admin/projects">Projets</Link>
        <Link to="/admin/partners">Partenaires</Link>
        <Link to="/admin/collaborators">Collaborateurs</Link>
        <Link to="/admin/clients">Clients</Link>
        <Link to="/admin/users">Utilisateurs</Link>
        <Link to="/admin/articles">Articles</Link>
        <Link to="/admin/contacts">Messages</Link>
        <div className="nav-dropdown">
          <button type="button" className="nav-dropdown-trigger" onClick={() => setToolsOpen(!toolsOpen)} aria-expanded={toolsOpen}>Plus ▾</button>
          {toolsOpen && <div className="nav-dropdown-menu">
            <Link to="/admin/feedback" onClick={() => setToolsOpen(false)}>Avis</Link>
            <Link to="/admin/faq" onClick={() => setToolsOpen(false)}>FAQ</Link>
            <Link to="/admin/services" onClick={() => setToolsOpen(false)}>Services</Link>
            <Link to="/admin/subscribers" onClick={() => setToolsOpen(false)}>Newsletter</Link>
            <Link to="/admin/settings" onClick={() => setToolsOpen(false)}>Configuration</Link>
          </div>}
        </div>
        {/* Déconnexion */}
        <button
          onClick={handleLogout}
          className="logout-btn"
          style={{
            background: "transparent",
            border: "none",
            color: "#c00",
            cursor: "pointer",
            fontWeight: "bold",
            marginLeft: "18px",
            fontSize: "16px"
          }}
        >
          Déconnexion
        </button>
      </nav>

      {/* Mobile menu button */}
      <button
        className="menu-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle menu"
      >
        {isOpen ? <X size={28} /> : <Menu size={28} />}
      </button>

      {/* Mobile dropdown menu */}
      {isOpen && (
        <div className="mobile-menu">
          <li><Link to="/admin/home" onClick={() => setIsOpen(false)}>Accueil</Link></li>
          <li><Link to="/admin/projects" onClick={() => setIsOpen(false)}>Projets</Link></li>
          <li><Link to="/admin/partners" onClick={() => setIsOpen(false)}>Partenaires</Link></li>
          <li><Link to="/admin/collaborators" onClick={() => setIsOpen(false)}>Collaborateurs</Link></li>
          <li><Link to="/admin/clients" onClick={() => setIsOpen(false)}>Clients</Link></li>
          <li><Link to="/admin/users" onClick={() => setIsOpen(false)}>Utilisateurs</Link></li>
          <li><Link to="/admin/articles" onClick={() => setIsOpen(false)}>Articles</Link></li>
          <li><Link to="/admin/feedback" onClick={() => setIsOpen(false)}>Avis</Link></li>
          <li><Link to="/admin/faq" onClick={() => setIsOpen(false)}>FAQ</Link></li>
          <li><Link to="/admin/services" onClick={() => setIsOpen(false)}>Services</Link></li>
          <li><Link to="/admin/contacts" onClick={() => setIsOpen(false)}>Messages</Link></li>
          <li><Link to="/admin/subscribers" onClick={() => setIsOpen(false)}>Newsletter</Link></li>
          <li><Link to="/admin/settings" onClick={() => setIsOpen(false)}>Configuration</Link></li>
          {/* Déconnexion */}
          <li>
            <button
              onClick={() => {
                setIsOpen(false);
                handleLogout();
              }}
              className="logout-btn"
              style={{
                background: "transparent",
                border: "none",
                color: "#c00",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: "16px",
                width: "100%",
                textAlign: "left"
              }}
            >
              Déconnexion
            </button>
          </li>
        </div>
      )}
    </header>
  );
}

export default Header;
